import { FC } from 'react';

import { StaticPercentSpan } from '@myn/mui';

import { PercentFieldProps } from '../types.js';
import TextVariant from './TextVariant.jsx';

type Props = Pick<
  PercentFieldProps,
  'scale' | 'value' | 'decimalLimit' | 'placeholder'
>;

const PercentVariant: FC<Props> = ({
  scale,
  value,
  decimalLimit,
  placeholder,
}) => {
  if (!value && value !== 0) {
    return <TextVariant scale={scale} value={null} placeholder={placeholder} />;
  }

  return (
    <StaticPercentSpan
      number={value}
      options={{
        minDecimals: decimalLimit,
        maxDecimals: decimalLimit,
        min: 0,
      }}
    />
  );
};

export default PercentVariant;
